module.exports = __webpack_public_path__ + "img/album-OkComputer.8649a316.jpg";